type CompanyAvatarClusterProps = {
  names: string[]
  /** Tailwind size class pair, e.g. 'w-9 h-9'. Defaults to a small cluster. */
  sizeClass?: string
  textClass?: string
  max?: number
}

export function CompanyAvatarCluster({
  names,
  sizeClass = 'w-8 h-8',
  textClass = 'text-sm',
  max = 3,
}: CompanyAvatarClusterProps) {
  const shown = names.slice(0, max)
  const extra = names.length - shown.length

  return (
    <div className="flex -space-x-2">
      {shown.map((name, index) => (
        <div
          key={`${name}-${index}`}
          className={`${sizeClass} rounded-full feature-soft-surface ring-2 ring-white flex items-center justify-center`}
          title={name}
        >
          <span className={`font-bold feature-soft-text ${textClass}`}>
            {(name.trim()[0] || '?').toUpperCase()}
          </span>
        </div>
      ))}
      {extra > 0 && (
        <div
          className={`${sizeClass} rounded-full feature-gradient-badge ring-2 ring-white flex items-center justify-center`}
        >
          <span className={`font-bold ${textClass}`}>+{extra}</span>
        </div>
      )}
    </div>
  )
}
